export const zoneStrippedDateString = (date: Date) => { 
    const offset = date.getTimezoneOffset();

    const offsetHours = Math.floor(offset / 60);

    return new Date(date.setHours(date.getHours() - offsetHours)).toISOString().split('T')[0];
}